import { makeStyles } from '@material-ui/core/styles';

export const UtilsStyles = makeStyles((theme) => ({

    root: {
        display: 'flex',
    },

    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 190,
    },
    search: {
        // border: "2px solid #2c8aaf",
        borderRadius: "5px",
        height: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 1px 1px 1px rgb(0 0 0 / 8%)",
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
    buttonSearch: {
        color: 'primary',
        position: 'absolute',
        top: '50%',
        left: '90%',
        marginTop: -26,
        [theme.breakpoints.up('xs')]: {
            left: '70%'
        },
        [theme.breakpoints.up('sm')]: {
            left: '85%'
        },
        [theme.breakpoints.up('md')]: {
            left: '85%'
        },
        [theme.breakpoints.up('lg')]: {
            left: '85%'
        },
        [theme.breakpoints.up('xl')]: {
            left: '88%'
        },
    },
}));